<div class="cw-layout">
  <app-workbench-header></app-workbench-header>
  <main class="cw-layout__main" aria-labelledby="pending-approval-title">
    <header class="cw-page-head">
      <div>
        <nav class="cw-breadcrumb" [attr.aria-label]="'pending_approval_jobs_title' | translate">
          <a routerLink="/dashboard">{{ "resource_admin_dashboard_title" | translate }}</a>
          <span aria-hidden="true">/</span>
          <span aria-current="page">{{ "pending_approval_jobs_title" | translate }}</span>
        </nav>
        <h1 class="cw-page-head__title" id="pending-approval-title">{{ "pending_approval_jobs_title" | translate }}</h1>
      </div>
      <div class="cw-thinksafe">
        <img class="cw-thinksafe__logo" src="/assets/thinksafe-logo.png" alt="ThinkSafe" />
        <span class="cw-thinksafe__link">{{ "pending_approval_jobs_health_safety" | translate }}</span>
      </div>
    </header>

    <section class="cw-filters" [attr.aria-label]="'open_jobs_summary_filters' | translate">
      <div class="cw-filters__item cw-card">
        <label class="cw-field__label" for="pending-site-name">{{ "open_jobs_summary_filter_site" | translate }}</label>
        <input class="cw-field__control" id="pending-site-name" type="search"
          [ngModel]="siteName()" (ngModelChange)="siteName.set($event)"
          [placeholder]="'open_jobs_summary_site_name' | translate" />
      </div>
      <div class="cw-filters__item cw-card">
        <label class="cw-field__label" for="pending-brand-name">{{ "open_jobs_summary_filter_brand" | translate }}</label>
        <select class="cw-field__control" id="pending-brand-name"
          [ngModel]="brandName()" (ngModelChange)="brandName.set($event)">
          <option value="">{{ "open_jobs_summary_show_all" | translate }}</option>
          @for (brand of brands(); track brand) {
            <option [value]="brand">{{ brand }}</option>
          }
        </select>
      </div>
    </section>

    <section class="cw-table-card cw-card" [attr.aria-label]="'pending_approval_jobs_title' | translate">
      <div class="cw-table-card__scroll">
        <table class="cw-table">
          <thead>
            <tr>
              <th class="cw-table__head-cell cw-table__site" scope="col">{{ "open_jobs_summary_site" | translate }}</th>
              <th class="cw-table__head-cell" scope="col">{{ "open_jobs_summary_brand" | translate }}</th>
              <th class="cw-table__head-cell cw-table__head-cell--num" scope="col">{{ "pending_approval_jobs_reactive" | translate }}</th>
              <th class="cw-table__head-cell cw-table__head-cell--num" scope="col">{{ "pending_approval_jobs_ppm" | translate }}</th>
            </tr>
          </thead>
          <tbody>
            @if (isLoading()) {
              <tr><td class="cw-table__empty" colspan="4" role="status">{{ "signin_lbl_loading_jobs" | translate }}</td></tr>
            } @else if (hasLoadError()) {
              <tr><td class="cw-table__empty" colspan="4" role="alert">{{ "pending_approval_jobs_load_failed" | translate }}</td></tr>
            } @else {
            @for (summary of filteredSummaries(); track summary.siteId) {
              <tr class="cw-table__row">
                <th class="cw-table__cell cw-table__cell--lead" scope="row">{{ summary.siteName || ("open_jobs_summary_not_available" | translate) }}</th>
                <td class="cw-table__cell" [attr.data-label]="'open_jobs_summary_brand' | translate">{{ summary.brandName || ("open_jobs_summary_not_available" | translate) }}</td>
                <td class="cw-table__cell cw-table__cell--num" [attr.data-label]="'pending_approval_jobs_reactive' | translate">
                  <button type="button" class="pending-count" [disabled]="summary.reactive === 0"
                    [attr.aria-label]="(summary.siteName || ('open_jobs_summary_not_available' | translate)) + ' - ' + ('pending_approval_jobs_reactive' | translate) + ': ' + summary.reactive"
                    (click)="openJobList(summary, 'New')">{{ summary.reactive }}</button>
                </td>
                <td class="cw-table__cell cw-table__cell--num" [attr.data-label]="'pending_approval_jobs_ppm' | translate">
                  <button type="button" class="pending-count" [disabled]="summary.ppm === 0"
                    [attr.aria-label]="(summary.siteName || ('open_jobs_summary_not_available' | translate)) + ' - ' + ('pending_approval_jobs_ppm' | translate) + ': ' + summary.ppm"
                    (click)="openJobList(summary, 'PPM')">{{ summary.ppm }}</button>
                </td>
              </tr>
            } @empty {
              <tr><td class="cw-table__empty" colspan="4">{{ "open_jobs_summary_empty" | translate }}</td></tr>
            }
            }
          </tbody>
        </table>
      </div>
    </section>
  </main>
  <app-workbench-footer></app-workbench-footer>
</div>
